import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['gender', 'pronoun', 'sterilization', 'alteredSelect'];

  connect() {
    this.syncView();
  }

  syncView() {
    const gender = this.genderTarget.value.toString().toLowerCase();
    const pronoun = { male: 'He', female: 'She' }[gender] || 'they';
    const sterilization =
      { male: 'neutered', female: 'spayed' }[gender] || 'sterilized';

    this.pronounTarget.innerText = pronoun;
    this.sterilizationTarget.innerText = sterilization;

    const alteredSelect = this.alteredSelectTarget;
    const currentValue = alteredSelect.value;

    // Get all available options from the data attribute
    const allOptionsData = JSON.parse(
      alteredSelect.dataset.ageNeuteredBreedAllOptions || '[]'
    );

    // Filter options to only those matching the current gender
    const matchingOptions = allOptionsData.filter((option) => {
      return option.gender?.toLowerCase() === gender;
    });

    // Remove all existing options
    while (alteredSelect.firstChild) {
      alteredSelect.removeChild(alteredSelect.firstChild);
    }

    // Add only the options matching the current gender
    matchingOptions.forEach((optionData) => {
      const option = document.createElement('option');
      option.value = optionData.value;
      option.textContent = optionData.text;
      option.setAttribute('data-gender', optionData.gender);
      alteredSelect.appendChild(option);
    });

    // Set the selected value - try to keep current value if it matches, otherwise use default
    const matchingOption = matchingOptions.find(
      (opt) => opt.value === currentValue
    );
    if (matchingOption) {
      alteredSelect.value = currentValue;
    } else {
      // Use the default option (the "yes" option matching the sterilization term)
      const defaultOption = matchingOptions.find(
        (opt) => opt.value.toLowerCase() === sterilization
      );
      if (defaultOption) {
        alteredSelect.value = defaultOption.value;
      } else if (matchingOptions.length > 0) {
        alteredSelect.value = matchingOptions[0].value;
      }
    }
  }
}
